const constants = {
    PASSWORD: 'Password',
}
export default constants;